import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import TransferClassroom from './TransferClassroom.jsx';

export default function TransferModal({
  isOpen,
  onClose,
  classroom,
  getClassRooms,
  classRooms = [],
  setParentState,
  translate = {},
  notify,
}) {
  const [showBlocked, setShowBlocked] = useState(false);

  if (!isOpen) return null;

  const stateProp = {
    openModalTransfer: isOpen,
    transferID: classroom,
    classRooms: classRooms,
    showBlocked: showBlocked,
  };

  const handleSuccess = () => {
    if (typeof getClassRooms === 'function') getClassRooms();
    if (typeof onClose === 'function') onClose();
    if (typeof notify === 'function') {
      notify({
        place: 'tr',
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {translate['sucesso'] || 'Sucesso'}.
            </span>
            <span data-notify="message">Os participantes selecionados foram transferidos.</span>
          </div>
        ),
        type: 'success',
        icon: 'ni ni-check-bold',
        autoDismiss: 7,
      });
    }
  };

  return (
    <Modal className="modal-dialog-centered" isOpen={Boolean(isOpen)}>
      <div className="modal-header bg-secondary">
        <h5 className="modal-title">Transferir participantes</h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => (typeof onClose === 'function' ? onClose() : null)}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body bg-secondary">
        <div className="mb-3">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="showBlocked"
              checked={showBlocked}
              onChange={(e) => setShowBlocked(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="showBlocked">
              Mostrar bloqueados também
            </label>
          </div>
        </div>
        {isOpen && (
          <TransferClassroom
            success={handleSuccess}
            getClassRooms={getClassRooms}
            classroom={classroom}
            state={stateProp}
            setState={typeof setParentState === 'function' ? setParentState : () => {}}
            translate={translate}
            notify={notify}
          />
        )}
      </div>
    </Modal>
  );
}
